import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["content", "showMoreButton"]
  static values = {
    truncateTextClasses: String,
    collapsed: Boolean
  }

  connect() {
    this.collapsedValue = this.collapsedValue || false
  }

  toggleCollapse(e) {
    e.stopPropagation()

    this.collapsedValue = !this.collapsedValue

    if (this.collapsedValue) {
      this.contentTarget.classList.add(...this.truncateTextClassesValue.split(" "))
      this.showMoreButtonTarget.classList.remove("hidden")
    } else {
      this.contentTarget.classList.remove(...this.truncateTextClassesValue.split(" "))
      this.showMoreButtonTarget.classList.add("hidden")
    }
  }
}